import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"

export class PanelPublish implements ClientPage {

  private countrySelect: HTMLSelectElement | null = null
  private stateSelect: HTMLSelectElement | null = null
  private wasUsaBefore: boolean = false

  getPageId = (): string => "publish-panel"

  execute = (): void => {
    const invoiceForm = document.getElementById("invoice-form")
    this.countrySelect = invoiceForm?.querySelector('select[name="country"]') as HTMLSelectElement | null
    this.stateSelect = invoiceForm?.querySelector('select[name="state"]') as HTMLSelectElement | null
    this.wasUsaBefore = this.countrySelect?.value === "US"

    this.setupStateSelect()

    this.countrySelect?.addEventListener("change", () => {
      this.setupStateSelect()
    })
  }

  private setupStateSelect = (): void => {
    const selectedCountryCode = this.countrySelect?.value
    const isUsaNow = selectedCountryCode === "US"

    if (isUsaNow) {
      if (!this.wasUsaBefore) {
        this.stateSelect.value = ""
        this.stateSelect.dispatchEvent(new Event("change", { bubbles: true }))
      }
      this.stateSelect?.parentElement?.classList?.remove("d-none")
    } else {
      this.stateSelect?.parentElement?.classList?.add("d-none")
      if (this.stateSelect) this.stateSelect.value = "WY" // Select any valid option, it won't get saved anyway
    }

    this.wasUsaBefore = isUsaNow
  }

  onPageClose = (): void => {}
}
